import { render, staticRenderFns } from "./UniversityResearchGroups.html?vue&type=template&id=0656dd45&scoped=true&external"
import script from "./UniversityResearchGroups.vue?vue&type=script&lang=js"
export * from "./UniversityResearchGroups.vue?vue&type=script&lang=js"
import style0 from "./UniversityResearchGroups.scss?vue&type=style&index=0&id=0656dd45&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0656dd45",
  null
  
)

export default component.exports